/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const WhisperTypes = {
    NO_ICON: '',
    INFO: 'info',
    RECORDING_SUCCESS: 'recording-success',
    ONE_PASS_SUCCESS: 'onepass-success',
} as const;

export type WhisperTypes = (typeof WhisperTypes)[keyof typeof WhisperTypes];
